<script>
import RawData from "@/components/widgets/raw-data.vue";
export default {
    name: "PrItems",
    components: {RawData},
    props: {
        pr: Object,
        isCancelled: Boolean    
    },
    methods: {
        updateResource(row, parent){
            this.$emit('updateResource', {
                data: row,
                parent: {...parent, prId: this.pr.id}
            })
        },
        removeResource(row, parent){
            this.$emit('removeResource', {
                data: row,
                parent: {...parent, prId: this.pr.id}
            })
        },
    }
}
</script>
<template>
    <div>
        <template v-for="(a, aIndex) in pr.prItems">
            <template>
                <div class="d-flex justify-content-between mt-3 " :key="`${pr.id}${aIndex}`">
                    <h5  class="mb-0 text-green">{{a.name}}</h5>
                    <div class="d-flex align-items-center">
                        <div class="font-size-16 text-green">
                            Total: {{ formatCurrency(a.total) }}
                        </div>
                    </div>
                </div>
            </template>
            <template v-for="(z, zIndex) in a.itemCategoryGroups">
                <template>
                    <h6 :key="`${pr.id}${aIndex}${zIndex}`" class="mt-2 text-pink ms-2">{{z.name}}</h6>
                </template>
                <template v-for="y in z.items">
                    <div
                        class="ms-3 mb-1 p-3 broken-border position-relative"
                        :key="y.id"
                    >
                        <RawData 
                            :data="y" 
                            v-if="$store.state.decrypt.isAdmin()" 
                            placement="left"
                            :keyId="`pr-item-${pr.id}${y.id}`"
                        />
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex">
                                <div class="d-flex align-items-center">
                                    <div class="font-size-20 text-yellow">
                                        {{ y.quantity }}
                                    </div>
                                    <i class="bx bx-x font-size-20 me-2 text-yellow"></i>
                                </div>
                                <div>
                                    <div>
                                        <div class="d-flex">
                                            {{y.itemName}}
                                            <a href="javascript:void(0);" @click="updateResource(y, z)" v-if="!isCancelled"><i class="bx bx-edit"></i></a>
                                            <a href="javascript:void(0);" @click="removeResource(y, z)" v-if="$store.state.decrypt.isAdmin() && !isCancelled"><i class="bx bx-trash text-danger"></i></a>
                                        </div>
                                        <div>
                                            <small>{{y.description}}</small>
                                            <small v-if="y.subType">
                                                <span class="text-green ms-1">[{{y.subType}}]</span>
                                            </small>
                                        </div>
                                        <div v-if="y.withChild"><small><a href="javascript:void(0);" @click="viewConsolidatedItems(y.id, pr)">(View consolidated items)</a></small></div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <div class="font-size-20 text-yellow mb-0">
                                    {{formatCurrency(y.total)}}
                                </div>
                                <div>
                                    <small>
                                        ({{formatCurrency(y.unitCost)}})
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
        </template>
    </div>
</template>